import {
  get_all_employees_and_departments,
  get_departments,
} from "./org-scope.api";

const default_deps_and_employees = {
  employees: {},
  employees_count_per_department: {},
  employees_full: {},
  departments: {},
};

export const get_orgs_employees_and_departments = async (
  is_preview: boolean
) => {
  if (is_preview) {
    const res = await get_all_employees_and_departments();
    if (res.success) {
      return res.value;
    } else {
      return default_deps_and_employees;
    }
  } else {
    const res = await get_departments();
    if (res.success) {
      return {
        ...default_deps_and_employees,
        departments: res.value,
      };
    } else {
      return default_deps_and_employees;
    }
  }
};
